import React, { CSSProperties, ReactNode } from 'react';
import Grid from '@mui/material/Grid';

export interface CenteredProps {
  style?: CSSProperties;
  className?: string;
  children: ReactNode;
}

const Centered = (props: CenteredProps) => {
  return (
    <Grid
      container
      direction="column"
      justifyContent="space-around"
      className={props.className}
      style={{
        // boxShadow:'0 0 1em red inset',
        // border:'2px dashed red',
        height: '100%',
        textAlign: 'center',
        ...props.style
      }}
    >
      <Grid item container direction="row" justifyContent="space-around">
        <Grid item>{props.children}</Grid>
      </Grid>
    </Grid>
  );
};

export default Centered;
